module.exports = __webpack_public_path__ + "static/fonts/poppins-v5-latin-700-d9f0e4b31953d6440559059230442358.woff2";